// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-img {
  max-height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/components/catalog-menu/catalog-menu.component.scss"],"names":[],"mappings":"AAAA;EAEE,gBAAA;AAAF","sourcesContent":[".style-img\n{\n  max-height: 50px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
